/* Project Import will be here */
import * as actions from '../actions/tmVoucher.Action';
/* Project Import will be here */

/* Const,Let & Var will be here */
let initialState = {
    selectedTMVouchers: {
        selectedTMVoucher: '',
        setTmVoucherModelVisibility: false
    }
};
/* Const,Let & Var will be here */

export default function (state = initialState, action) {
    switch (action.type) {
        case actions.TM_VOUCHER_POPUP:
            return {
                ...state,
                selectedTMVouchers: {
                    ...state.selectedTMVouchers,
                    setTmVoucherModelVisibility: action.setTmVoucherModelVisibility
                }
            };
        case actions.SELECTED_TM_VOUCHER_DATA:
            return {
                ...state,
                selectedTMVouchers: {
                    ...state.selectedTMVouchers,
                    selectedTMVoucher: action.selectedTMVoucherData
                }
            };
        default:
            return state;
    }
}